/**
 * 로그아웃 처리
 * auth-check.js의 clearUserInfo 함수를 사용하여 사용자 정보 삭제
 */
function logout() {
  // auth-check.js의 clearUserInfo 호출
  if (window.clearUserInfo) {
    window.clearUserInfo();
  } else {
    // fallback: 직접 sessionStorage 삭제
    sessionStorage.clear();
  }
  
  alert('로그아웃 되었습니다.');
  window.location.replace('/');
}

window.logout = logout;

